module.exports = __webpack_public_path__ + "static/img/coupon.e501989c.png";